module.exports = new __parcel__URL__("Mariam_Shengelia.da6aee03.jpg").toString();